import {brandConfigObjectMap, Brands} from "@/brand/brandConfig";

export const brandConfigMap = new Map();

brandConfigMap.set('http://localhost:8096', getBrandConfig(Brands.How2AiThailandAis));
/* ais-how2ai is the per-service host (OPS-859, confirmed 2026-09-02). ais. is becoming the
   umbrella for AIS Thailand, so it stays mapped here until Commercial repoint it. */
brandConfigMap.set('https://ais-how2ai.th-penverse.com', getBrandConfig(Brands.How2AiThailandAis));
brandConfigMap.set('https://ais.th-penverse.com', getBrandConfig(Brands.How2AiThailandAis));
brandConfigMap.set('default', getBrandConfig(Brands.How2AiThailandAis));

export function getBrandConfig(brand) {
    const brandConfigObject = brandConfigObjectMap.get(brand);
    return {
        brand,
        assetBrand: brandConfigObject?.assetBrand ?? brand,
        ...brandConfigObject
    }
}
